"use client";

import { signInAction, signInWithRedirect, signOutWithRedirect } from "@/actions/auth";
import { Button } from "@/components/ui/button";
import { clearAllStorage } from "@/hooks/use-local-storage";
import { LogIn } from "lucide-react";
import { useEffect, useTransition } from "react";
import { Logger } from "@/sentry/logger";

interface LoginFormProps {
  isSwitchAccount?: boolean;
  callbackUrl?: string;
}

export const LoginForm = ({ isSwitchAccount = false, callbackUrl }: LoginFormProps) => {
  const [isPending, startTransition] = useTransition();

  const handleSignIn = () => {
    startTransition(async () => {
      try {
        if (isSwitchAccount) {
          const loginUrl = callbackUrl
            ? `/login?callbackUrl=${encodeURIComponent(callbackUrl)}`
            : "/login";
          await signOutWithRedirect(loginUrl);
        } else if (callbackUrl) {
          await signInWithRedirect(callbackUrl);
        } else {
          await signInAction();
        }
      } catch (error) {
        Logger.error("Error initiating Auth0 login", {
          timestamp: new Date().toISOString(),
          message: "Error in LoginForm component while initiating Auth0 login",
          component: "LoginForm",
          error,
        });
      }
    });
  };

  useEffect(() => {
    clearAllStorage();
  }, []);

  return (
    <Button
      type="button"
      className="w-full py-3 text-[15px] font-medium"
      disabled={isPending}
      onClick={handleSignIn}
    >
      <LogIn className="size-4" />
      {isPending
        ? "Redirecting..."
        : isSwitchAccount
          ? "Switch account"
          : "Continue with Auth0"}
    </Button>
  );
};
